import { IUntypedCommand, Topics } from '@zaplify/common';
export class ReleaseProspectsCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(
        readonly userId: string,
        readonly userOrganizationId: string,
        readonly prospectIds: string[],
        readonly options?: { force?: boolean },
    ) {
        super();
    }
}
